import './register.css';
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUserType } from '../../redux/slices/authSlice';

function Register() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userType, error } = useSelector((state) => state.auth);
    
    const [currentSlide, setCurrentSlide] = useState(0);
    const [selectedUserType, setSelectedUserType] = useState(userType);

    const slides = [
        {
            title: "منصة علمني التعليمية",
            content: "أكاديميتنا العملية تهدف الى تزويد المتعلمين بالمهارات العملية والتطبيقية التي تؤهلهم لسوق العمل من خلال برامج تدريبية متطورة وتجربة تعليمية تفاعلية."
        },
        {
            title: "تعلم بطريقة ممتعة",
            content: "نقدم محتوى تعليمي تفاعلي وممتع يساعد الطلاب على فهم المفاهيم بسهولة وتطبيقها في الحياة العملية."
        },
        {
            title: "محتوى عالي الجودة",
            content: "محتوى تعليمي متميز ومحدث باستمرار لضمان حصول الطلاب على أفضل تجربة تعليمية ممكنة."
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 4000);

        return () => clearInterval(interval);
    }, [slides.length]);

    // إضافة انيميشن للعناصر عند التحميل
    useEffect(() => {
        const elements = document.querySelectorAll('.login-card, .login-info-section');
        elements.forEach((el, index) => {
            el.style.animationDelay = `${index * 0.2}s`;
        });

        // إضافة انيميشن للعناصر الداخلية
        const innerElements = document.querySelectorAll('.login-card-title, .login-card-subtitle, .login-input-group, .login-btn, .login-card-footer, .login-back-link');
        innerElements.forEach((el, index) => {
            el.style.animationDelay = `${(index + 2) * 0.1}s`;
        });

        // إضافة انيميشن للعناصر المعلوماتية
        const infoElements = document.querySelectorAll('.login-brand, .login-info-slider, .login-indicators');
        infoElements.forEach((el, index) => {
            el.style.animationDelay = `${(index + 1) * 0.2}s`;
        });
    }, []);

    const handleUserTypeSelect = (type) => {
        setSelectedUserType(type);
        dispatch(setUserType(type));
    };

    const handleCreateAccount = () => {
        if (selectedUserType) {
            navigate('/registerPhone');
        }
    };

    return (
        <div className="login-page register-page">
            <div className="login-overlay">
                <div className="login-wrapper">
                    {/* Right Info */}
                    <div className="login-info-section">
                        <h1 className="login-brand">علمني <i className="login-icon-book"></i></h1>

                        <div className="login-info-slider">
                            {slides.map((slide, index) => (
                                <div
                                    key={index}
                                    className={`login-slide ${index === currentSlide ? 'active' : ''}`}
                                >
                                    <h3 className="login-info-title">{slide.title}</h3>
                                    <p className="login-info-paragraph">{slide.content}</p>
                                </div>
                            ))}
                        </div>

                        {/* Indicators */}
                        <div className="login-indicators">
                            {slides.map((_, index) => (
                                <span
                                    key={index}
                                    className={index === currentSlide ? 'active' : ''}
                                    onClick={() => setCurrentSlide(index)}
                                    style={{ cursor: 'pointer' }}
                                ></span>
                            ))}
                        </div>
                    </div>

                    {/* Left Form */}
                    <div className="login-card register-card">
                        <h2 className="login-card-title">من انت ؟</h2>
                        <p className="login-card-subtitle">
                            اختر نوع حسابك لبدء استخدام المنصة.
                        </p>

                        {/* User Type Selection */}
                        <div className="user-type-selection">
                            <button 
                                className={`user-type-btn ${selectedUserType === 'student' ? 'active' : ''}`}
                                onClick={() => handleUserTypeSelect('student')}
                            >
                                <i className="user-type-icon">👨‍🎓</i>
                                <span>طالب</span>
                            </button>
                            <button 
                                className={`user-type-btn ${selectedUserType === 'teacher' ? 'active' : ''}`}
                                onClick={() => handleUserTypeSelect('teacher')}
                            >
                                <i className="user-type-icon">👨‍🏫</i>
                                <span>معلم</span>
                            </button>
                            <button 
                                className={`user-type-btn ${selectedUserType === 'parent' ? 'active' : ''}`}
                                onClick={() => handleUserTypeSelect('parent')}
                            >
                                <i className="user-type-icon">👨‍👩‍👧‍👦</i>
                                <span>ولي أمر</span>
                            </button>
                        </div>

                        {/* Error Message */}
                        {error && (
                            <div className="error-message">
                                {error}
                            </div>
                        )}

                        {/* Button */}
                        <button 
                            className={`login-btn ${!selectedUserType ? 'disabled' : ''}`}
                            onClick={handleCreateAccount}
                            disabled={!selectedUserType}
                        >
                            إنشاء
                        </button>

                        <p className="login-card-footer">
                            لديك حساب بالفعل ؟ <a href="/login" className="login-link">تسجيل الدخول</a>
                        </p>
                        <a href="/" className="login-back-link">العودة للصفحة الرئيسية</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Register;
